import { render } from "./AddAcknowledgement.vue?vue&type=template&id=6880724e"
import script from "./AddAcknowledgement.vue?vue&type=script&lang=js"
export * from "./AddAcknowledgement.vue?vue&type=script&lang=js"

import "./AddAcknowledgement.vue?vue&type=style&index=0&id=6880724e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__